export default "__VITE_ASSET__ChDDt4S4__"